module.exports = __webpack_public_path__ + "media/images/badges/purebarre-badge-2dacd8f5b76a70bdefb11167aac47f67.png";